export const BuildInfo = {timestamp:1779400965000}
